<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card class="px-5 py-3">
          <template v-slot:heading>
            <div class="headline mt-3 font-weight-light">
              {{ $t('cadastro') }}
            </div>
          </template>
          <v-form>
            <v-container class="py-0">
              <v-col
                cols="12"
                md="6"
              >
                <p v-if="erros.length">
                  <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
                  <ul>
                    <li v-for="item in erros" :key="item" >
                      {{ item }}
                    </li>
                  </ul>
                </p>
               </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.nome"
                  :error="nomeErro"
                  class="purple-input"
                  label="Nome:"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.telefone"
                  v-mask="maskFone"
                  v-validate="'required|numeric'"
                  label="Celular:"
                  class="purple-input"
                  :error="telefoneErro"
                  data-vv-name="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.cpf"
                  v-mask="maskCpf"
                  :error="telefoneErro"
                  label="CPF:"
                  class="purple-input"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="form.termosAceito"
                  :disabled="form.termosAceito"
                  :error="termosAceitoErro"
                  label="Aceito os termos de uso do W3Gestão?"
                  class="purple-input"
                />
              </v-col>
              <v-col
                class="text-right"
                cols="12"
              >
                <v-btn
                  class="mx-0 font-weight-light"
                  color="success"
                  @click="doSalva"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mask } from 'vue-the-mask'
import { log } from 'util'
  
  export default {
    directives: {
      mask,
    },
    data: () => ({
      form: {
        nome: '',
        cpf: '',
        telefone: '',
        termosAceito: false,
      },
      maskFone: '(##) #####-####',
      maskCpf: '###.###.###-##',
      chaveFuncionarioMobile: '',
      nomeErro: false,
      cpfErro: false,
      telefoneErro: false,
      termosAceitoErro: false,
      erros: [],
    }),
    mounted () {
      if (localStorage.termosAceitoFuncionarioMobile) {
        this.form.termosAceito = localStorage.termosAceitoFuncionarioMobile
      }
      if (localStorage.nomeFuncionarioMobile) {
        this.form.nome = localStorage.nomeFuncionarioMobile
      }
      if (localStorage.cpfFuncionarioMobile) {
        this.form.cpf = localStorage.cpfFuncionarioMobile
      }
      if (localStorage.telefoneFuncionarioMobile) {
        this.form.telefone = localStorage.telefoneFuncionarioMobile
      }
    },
    methods: {
      doSalva () {
        var funcionarioMobile
        var chaveTemp
        if (!this.doValidate()) {
          return
        } 
        if (!localStorage.chaveFuncionarioMobile) {
          var txt = this.form.telefone
          var numb = txt.match(/\d/g)
          numb = numb.join('')
          var d = new Date()
          var n = d.valueOf()
          chaveTemp = 'W3GF.' + numb + '.' + n
          funcionarioMobile = {
            'chave': chaveTemp,
            'nome': this.form.nome,
            'telefone': this.form.telefone,
            'cpf': this.form.cpf
          }
        } else {
          funcionarioMobile = {
            'chave': localStorage.chaveFuncionarioMobile,
            'nome': this.form.nome,
            'telefone': this.form.telefone,
            'cpf': this.form.cpf
          }
        }
        this.$http.post('/ProjetoX/rest/externo/funcionario/mobile/registro', funcionarioMobile).then(response => {
          if (!localStorage.chaveFuncionarioMobile) {
            localStorage.chaveFuncionarioMobile = chaveTemp
          }
          localStorage.nomeFuncionarioMobile = this.form.nome
          localStorage.cpfFuncionarioMobile = this.form.cpf
          localStorage.telefoneFuncionarioMobile = this.form.telefone
          localStorage.termosAceitoFuncionarioMobile = this.form.termosAceito
          alert('Cadastro salvo com sucesso!')
          this.$router.push({ path: '/' })
        }).catch(error => {
          console.log(error);
          alert('Erro ao salvar cadastro.')
        })
      },
      doValidate () {
        this.erros = []
     
        if (!this.form.nome) {
          this.erros.push('O Nome é obrigatório.')
          this.nomeErro = true
        } else { 
          this.nomeErro = false 
        }
        if (!this.form.cpf) {
          this.erros.push('O CPF é obrigatório.')
          this.cpfErro = true
        } else if (this.form.cpf.length !== 14) {
          this.erros.push('O CPF invalido.')
          this.cpfErro = true
        } else { 
          this.cpfErro = false 
        }
        if (!this.form.telefone) {
          this.erros.push('O Telefone é obrigatório.')
          this.telefoneErro = true
        } else if (this.form.telefone.length !== 15) {
          this.erros.push('O telefone invalido.')
          this.telefoneErro = true
        } else { 
          this.telefoneErro = false 
        }
        if (!this.form.termosAceito) {
          this.erros.push('Termo não aceito.')
          this.termosAceitoErro = true
        } else { 
          this.termosAceitoErro = false 
        }
        if (this.erros.length === 0) {
          return true
        }   
      },
    },
  }
</script>
